import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

/**
 * Set the nurse's current room status in Firestore.
 * @param {string} nurseUid - Nurse's user ID
 * @param {string|null} roomUid - Room ID or null if not in a room
 */
export async function setNurseCurrentRoom(nurseUid, roomUid) {
  const ref = doc(db, 'on_demand_access', nurseUid);
  if (roomUid) {
    await setDoc(ref, {
      currentRoomUid: roomUid,
      currentRoomSetAtMs: Date.now(),
      currentRoomSetServerTimestamp: serverTimestamp(),
    }, { merge: true });
  } else {
    await setDoc(ref, {
      currentRoomUid: null,
      currentRoomSetAtMs: null,
      currentRoomSetServerTimestamp: null,
    }, { merge: true });
  }
}

/**
 * Get the nurse's current room status from Firestore.
 * @param {string} nurseUid - Nurse's user ID
 * @returns {Promise<{roomUid: string|null, timestamp: number}|null>}
 */
export async function getNurseCurrentRoom(nurseUid) {
  const ref = doc(db, 'on_demand_access', nurseUid);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  const data = snap.data();
  if (!data.currentRoomUid || !data.currentRoomSetAtMs) {
    return null;
  }
  return {
    roomUid: data.currentRoomUid,
    timestamp: data.currentRoomSetAtMs || 0,
  };
}
